// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__JbLWD","row":"Node_row__h6NKn","label":"Node_label__5vbpX","footer":"Node_footer__2QDjg"};